import { motion } from "framer-motion";
export function About() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-16" data-mp="fmad620jimhd">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl" data-id="element-17" data-mp="2psibjdmyl9wk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="flex flex-col items-center gap-6 rounded-3xl border border-slate-100 bg-slate-50 p-6 text-center sm:p-9" data-id="element-18" data-mp="2ttbwpz90oalr">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/896143db-632e-40d2-91c1-00e205eecae5.jpg" alt="Dra. Karito" className="h-24 w-24 rounded-full object-cover ring-4 ring-[#1e88e5]/20 sm:h-28 sm:w-28" data-id="element-19" data-mp="38pjgwzkfdc11" />
          <div data-id="element-20" data-mp="3mhrcinzz2wy5">
            <h2 className="font-head text-xl font-800 text-[#0f2547] sm:text-2xl" data-id="element-21" data-mp="3mi9dtz1hs1cx">
              Sobre el Sistema Maestro de Planificación con Alineadores
            </h2>
            <div className="mx-auto mt-4 max-w-xl space-y-3 text-sm leading-relaxed text-slate-600 sm:text-[15px]" data-id="element-22" data-mp="3rehrt93ydoii">
              <p data-id="element-23" data-mp="2gse1i43mlwy1">
                Sabemos que una buena planificación marca la diferencia entre un
                tratamiento predecible y una cadena interminable de
                refinamientos.
              </p>
              <p data-id="element-24" data-mp="27s7t2wmsbn5q">
                Por eso desarrollamos una biblioteca clínica diseñada para
                ayudar a odontólogos y ortodoncistas a tomar mejores decisiones
                en cada etapa del tratamiento.
              </p>
              <p className="font-600 text-[#0f2547]" data-id="element-25" data-mp="30gwwj2bbc4kn">
                Aquí no encontrarás teoría innecesaria ni contenido de relleno.
                Encontrarás protocolos prácticos, herramientas visuales y un
                Sistema Visual de Decisión Clínica (SVDC) que podrás aplicar
                desde tu próximo caso.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}